'use es6';

import { createSelector } from 'reselect';
import * as Scopes from 'DesignData/constants/Scopes';
export const getPortal = state => state.auth.portal;
export const getUser = state => state.auth.user;
export const getScopes = state => state.auth.user.scopes;
export const getGates = state => state.auth.gates;
export const getUserAndPortal = createSelector([getPortal, getUser], (portal, user) => ({
  portal,
  user
}));
export const getPortalId = createSelector([getPortal], portal => portal ? portal.portal_id : null);
export const getPortalDomain = createSelector([getPortal], portal => portal ? portal.domain : null);
export const getUserId = createSelector([getUser], user => user ? user.user_id : null);
export const getUserAndPortalIds = createSelector([getUserId, getPortalId], (userId, portalId) => ({
  userId,
  portalId
}));
export const getUserEmail = createSelector([getUser], user => user ? user.email : null);
export const isUngated = (state, props) => {
  const gatesData = getGates(state);
  return Boolean(gatesData[props.gate]);
};
export const isScoped = createSelector([getScopes], scopes => {
  return scope => scopes ? scopes.includes(scope) : false;
});
export const getIsHubSpotter = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.JITA_USER));
export const hasEmailAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.EMAIL_FULL_EDITING));
export const getSkipOnboarding = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.SKIP_ONBOARDING));
export const getHasMembershipTemplateAccess = createSelector([isScoped], hasScope => hasScope(Scopes.MARKETING_CONTENT_RESTRICTED_WRITE) || hasScope(Scopes.SERVICE_CONTENT_RESTRICTED_WRITE));
export const getHasDndTemplateAccess = createSelector([isScoped], hasScope => hasScope(Scopes.CMS_DND_TEMPLATES));
export const getHasGlobalContentEditorAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.GLOBAL_CONTENT_WRITE_ACCESS));
export const getHasServerlessFunctions = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.SERVERLESS_FUNCTIONS));
export const getUserHasWriteAccess = createSelector([isScoped], hasScope => hasScope(Scopes.SOURCE_CODE_WRITE));
export const getUserHasReadAccessOnly = createSelector([isScoped], hasScope => !hasScope(Scopes.SOURCE_CODE_WRITE) && hasScope(Scopes.SOURCE_CODE_READ));
export const getHasMarketplacePostingAccess = createSelector([isScoped], hasScope => hasScope(Scopes.MARKETPLACE_ASSET_PROVIDER));
export const getHasSystemPagesAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.SYSTEM_PAGES_ACCESS));
export const getHasSitePasswordAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.LANDING_PASSWORD_ACCESS) || getIsScoped(Scopes.SITE_PASSWORD_ACCESS));
export const getHasSiteSearchAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.SITE_SEARCH_ACCESS));
export const getHasCMSFreeLandingPageAccess = createSelector(getScopes, scopes => !scopes.includes(Scopes.LANDING_PAGES_ADVANCED_WRITE) && !scopes.includes(Scopes.LANDING_PAGES_NO_BRANDING));
export const getHasDataCollectorQueryAccess = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.COLLECTOR_DATA_QUERY_READ));
export const getHasDataCollectorExecute = createSelector([isScoped], getIsScoped => getIsScoped(Scopes.COLLECTOR_DATA_QUERY_EXECUTE));